/**
 * Normalizes a raw locale string to xx-XX: language lowercase, region uppercase (e.g. en-us -> en-US).
 * If no region is present, returns the language part only (e.g. "en" -> "en").
 */
export function formatUserLocale(rawLocale: string): string {
  const [lang, region] = rawLocale.toLowerCase().split('-');

  return region ? `${lang}-${region.toUpperCase()}` : lang;
}
